import React, { FC } from "react"
import tw from "twin.macro"
import styled from "styled-components"

const LastWord = styled.span`
  ${tw`text-yellow`}
`

// eslint-disable-next-line import/prefer-default-export
export const LastWordColoured: FC<{ text: string }> = ({ text }) => {
  const titleWords = text.split(" ")
  const lastWord = titleWords.pop()
  return (
    <>
      {titleWords.map(w => `${w} `)}
      <LastWord>{lastWord}</LastWord>
    </>
  )
}
